import { LanguageService } from "./../../../services";
import { LanguageOutputModel } from "../../../models";
import { createActions } from "redux-actions";
import { Dispatch } from "redux";
import { loadCallback } from "../../../utils";
import { RootState, TCb } from "../../../models";

export const AllLanguageListAcionTypes = createActions({
  LOAD_ALL_LANGUAGE_START: (data) => data,
  LOAD_ALL_LANGUAGE_SUCCESS: (data) => data,
});

const getAllLanguages = (cb?: TCb) => (dispatch: Dispatch, getState: () => RootState) => {
  dispatch(
    AllLanguageListAcionTypes.loadAllLanguageStart({
      loading: true,
      data: [],
    }),
  );

  LanguageService.getLanguages()
    .then((res) => {
      dispatch(
        AllLanguageListAcionTypes.loadAllLanguageSuccess({
          loading: false,
          data: res.data.data.map((e: LanguageOutputModel) => {
            return {
              ...e,
              isPrimary: e.code === "EN",
            };
          }),
        }),
      );
      loadCallback(cb?.success);
    })
    .catch((err) => {});
};

export const AllLanguageListActions = {
  getAllLanguages,
};
